import HeroSectionCarousel from "../carousel";
import "./index.css";
import gif from "../../assets/images/orbit-screen.gif";
import {
  ChartLine,
  ChartPie,
  CircleGauge,
  Handshake,
  Info,
  LifeBuoy,
  SquareStack,
  Mail,
  MapPin,
  Phone,
} from "lucide-react";
import { StockMarket } from "react-ts-tradingview-widgets";

const data = [
  {
    heading: "Execution Transparency",
    para: "our aim is to give you all the information you need to make smarter trades. We understand that in today’s complex market environment, transactional transparency is an increasingly important part of execution performance. The more transparent your trading partner, the more you know and the more power you have.",
  },
  {
    heading: "Lowest Commission",
    para: "Orbit Securities you get a transparent pricing structure and a secure and regulated trading environment with low commissions. As an active trader you can also qualify for lower fees and extra benefits. We are focused on your investment in the workplace to provide you with the best products and services in the stock market, while also striving to increase access and transparency in trading.",
  },
  {
    heading: "Integrated Digital Support",
    para: "Access our self-service support center, email helpdesk and our Dedicated well-experienced and well-educated equity analysts is available to advise Support. Exclusive WhatsApp group for disseminating technical/fundamental recommendations and real-time market news. Live call support for placing orders, IT support and other assistance available for requisitioning.",
  },
  {
    heading: "Customized Research",
    para: "Deep emerging market intelligence, analysis and functionality, with specialized tools. Fundamental analysis with the help of technical analysis charts, stock financial statements and real-time market news, the overall economy including key indicators such as interest rates, inflation and other relevant aspects of monetary and fiscal policy etc.",
  },
];

export const data1 = [
  {
    heading: "VARIETY OF PRODUCTS",
    para: "Online Trading Terminals V.Trade Smartphone, Tablet & PC Trading Digital Account Opening From",
    logo: <Handshake className="trading-icon" />,
  },
  {
    heading: "OUTSTANDING SUPPORT",
    para: "Live News SMS, Live Streaming Trading Central Reports Award-winning Client Services",
    logo: <LifeBuoy className="trading-icon" />,
  },
  {
    heading: "LEVERAGED TRADING",
    para: "Trade with extra buying power using Margin Trading (MTS) and Margin Financing (MFS) facilities, allowing you to invest more than your available funds for greater potential returns.",
    logo: <ChartLine className="trading-icon" />,
  },
  {
    heading: "MARKET EXECUTION",
    para: "Experience fast and smooth trade execution with no delays or re-quotes, supported by KATS (Karachi Automated Trading System), certified traders, and a dedicated front desk team.",
    logo: <ChartPie className="trading-icon" />,
  },
  {
    heading: "DEEP LIQUIDITY",
    para: "Instant liquidity with digital banking and easy fund transfers.",
    logo: <CircleGauge className="trading-icon" />,
  },
  {
    heading: "LOWEST COMMISSION",
    para: "Lowest Commission Charges Same as per PSX Standard",
    logo: <SquareStack className="trading-icon" />,
  },
];

const data2 = [
  {
    heading: "Registered Office",
    phoneNo: "(+92) 21-32622075",
    address:
      "Suite 1101, 11th Floor, Trade Center Near Jung Press, I.I Chundrigar Road, Karachi",
    email: "info@orbitsecurities.com.pk",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d14481.540450652528!2d67.0102072!3d24.8506932!3m2!1i1024!2i768!4f13.1!2m1!1sSuite%201101%2011th%20Floor%20Trade%20Center%20Near%20Jung%20Press%20.ii%20Chundrigar%20Road%20Karachi!5e0!3m2!1sen!2s!4v1741125564598!5m2!1sen!2s",
  },
  {
    heading: "Branch Office",
    phoneNo: "(+92) 21-32470791-4",
    address:
      "Suite 92, 2nd Floor, PSX Main Building, I.I Chundrigar Road, Karachi",
    email: "info@orbitsecurities.com.pk",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.439464337989!2d66.99372217832995!3d24.84883588885685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06f79533c3%3A0x688986c88631e98a!2sI.I%20Chundrigar%20Rd%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1741125744685!5m2!1sen!2s",
  },
];
export default function Home() {
  return (
    <>
      <HeroSectionCarousel />
      <div className="home-box-sec"></div>

      <div className="home-sec-2">
        <h1 className="leading">OUR STRATEGY & OBJECTIVE</h1>
        <hr className="white-line margin-bottom" />
        <p className="leading">
          To constantly assess and monitor our clients’ needs and provide
          premium quality services to meet these needs. To develop and provide
          financial products and services with excellent front and back-office
          execution to all our clients and quality system automation.
        </p>

        <div className="home-sec-3">
          <div class="kite-shape opacity">
            <p>MISSION</p>
          </div>
          <div class="kite-shape opacity">
            <p>STRATEGY</p>
          </div>
          <div class="kite-shape opacity">
            <p>OBJECTIVE</p>
          </div>
          <div class="kite-shape opacity">
            <p>CLIENTS</p>
          </div>
        </div>

        <div className="home-sec-4 opacity">
          <h3>OUR MISSION</h3>
          <p>
            To maintain our high profile and continue providing premium quality
            service to our clients.
          </p>
        </div>
        <div className="sec-4">
          <div className="flex-col-between">
            <h1>OUR SERVICES</h1>
            <p>
              The Company aims at exceeding the expectations of every client by
              providing outstanding customer service, reliable, and timely
              information and maintain the competitive edge of being more
              professional and customer-oriented.
            </p>
            <ul>
              <li>BROKERAGE SERVICES</li>
              <li>RESEARCH DETERMENT</li>
              <li>PORTFOLIO & ITS ACCESS</li>
              <li>INFORMATION PRIVACY POLICY</li>
            </ul>
          </div>
          <img src={gif} alt="gif" />
        </div>
      </div>

      <div className="home-sec-5">
        <h1 className="leading">TRADING TOOLS & SERVICES</h1>
        <hr className="white-line margin-bottom" />
        <p className="leading">
          Get instant access to the best tools and advice to get the most out of
          your investment. We are focusing on the ultimate safety of client
          funds to enhance their profitability reach.
        </p>
        <div className="flex-col-center">
          <div className="sub-home-sec-5">
            {data.map((v, i) => (
              <div className="flex-sec-5" key={i}>
                <div className="icon1">
                  <div className="icon">
                    <Info fill="black" size={30} />
                  </div>
                </div>
                <div className="sub-sec-5">
                  <h3 className="leading">{v.heading}</h3>
                  <p className="leading">{v.para}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="home-sec-6">
        <h1 className="leading">Key Features</h1>
        <hr className="white-line margin-bottom" />

        <div className="flex-col-center">
          <div className="sub-home-sec-6">
            {data1.map((v, i) => (
              <div className="flex-sec-6" key={i}>
                <div className="icon2">{v.logo}</div>
                <div className="sub-sec-6">
                  <h3 className="leading">{v.heading}</h3>
                  <p className="leading">{v.para}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="home-sec-7">
        <h1 className="leading">KEEP IN TOUCH</h1>
        <hr className="white-line margin-bottom" />
        <div className="">
          {data2.map((v, i) => (
            <div className="keep-in-touch">
              <p>{v.heading}</p>
              <div className="sub-div">
                <p>{v.phoneNo}</p>
                <p>{v.address}</p>
                <p className="email">{v.email}</p>
              </div>
              <div className="map-container">{v.location}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

const TradingTools = () => {
  return (
    <div className="home-sec-5">
      <h1 className="leading">TRADING TOOLS & SERVICES</h1>
      <hr className="white-line margin-bottom" />
      <p className="leading">
        Get instant access to the best tools and advice to get the most out of
        your investment. We are focusing on the ultimate safety of client funds
        to enhance their profitability reach.
      </p>
      <div className="flex-col-center">
        <div className="sub-home-sec-5">
          {data.map((v, i) => (
            <div className="flex-sec-5" key={i}>
              <div className="icon1">
                <div className="icon">
                  <Info fill="black" size={30} />
                </div>
              </div>
              <div className="sub-sec-5">
                <h3 className="leading">{v.heading}</h3>
                <p className="leading">{v.para}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const ContactLocations = () => {
  return (
    <div className="contact-section">
      <h2 className="contact-title">📍 Our Locations</h2>
      <div className="contact-wrapper">
        {data2.map((item, index) => (
          <div key={index} className="contact-card">
            <h3 className="contact-heading">{item.heading}</h3>
            <div className="contact-details">
              <div className="contact-item">
                <MapPin size={18} className="contact-icon" />
                <span>{item.address}</span>
              </div>
              <div className="contact-item">
                <Phone size={18} className="contact-icon" />
                <span>{item.phoneNo}</span>
              </div>
              <div className="contact-item">
                <Mail size={18} className="contact-icon" />
                <a href={`mailto:${item.email}`} className="email-link">
                  {item.email}
                </a>
              </div>
            </div>
            <iframe
              src={item.mapSrc}
              className="map-frame"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`Google Map - ${item.heading}`}
            ></iframe>
          </div>
        ))}
      </div>
    </div>
  );
};

export const StockMarketWidget = () => {
  console.log("StockMarketWidget rendered");
  return (
    <div className="market-container">
      {/* Left Section: Stock Market (70%) */}
      <div className="stock-market">
        <StockMarket colorTheme="white" height={550} width="100%" />
      </div>

      {/* Right Section: Market Data (30%) */}
      <div className="market-data">
        <h2>📈 Live Market Gainers and Losers tracking</h2>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam iusto, nisi illo nulla alias fugiat repudiandae unde ab maxime placeat facere, dicta deleniti ipsam animi expedita quam minus perferendis veniam?</p>
        <ul className="market-list">
          <li>🔥 Live Gainers Tracking</li>
          <li>📉 Live Losers Tracking</li>
          <li>📊 Live Market Data</li>
          <li>💰 Live Cryptocurrency Price</li>
          <li>⏳ Past Coin Price Check</li>
        </ul>
      </div>
    </div>
  );
};


export { TradingTools };
